'use strict'

/**
 * Object with all validations of the login form inputs.
 *
 * @author C Camilo Castellanos
 * @since 28/08/2018 5:33 PM
 * @version 1.0.0
 */
export default {
  obraId: {
    required: true
  },
  campanaDonacionId: {
    required: true
  },
  tipoDocumentoId: {
    required: true
  },
  numeroDocumento: {
    required: true,
    max: 20,
    alpha_num: true
  },
  nombre: {
    required: true,
    max: 30,
    alpha_spaces: true
  },
  apellidos: {
    required: true,
    max: 30,
    alpha_spaces: true
  },
  razonSocial: {
    required: true,
    max: 30
  },
  correoElectronico: {
    required: true,
    max: 60,
    email: true
  },
  confirmacionCorreoElectronico: {
    required: true,
    max: 60,
    email: true,
    confirmed: 'correoElectronico'
  },
  telefono: {
    max: 15,
    required: true,
    numeric: true
  },
  valor: {
    required: true,
    max: 30,
    min_value: 1
  },
  paisId: {
    required: true
  },
  ciudad: {
    required: true,
    max: 60
  },
  direccion: {
    required: false,
    max: 100
  },
  aceptaTerminosCondiciones: {
    required: true
  },
  aceptaTratamientoDatos: {
    required: false
  },
  tipoMoneda: {
    required: true
  }
}
